import { use18n } from 'src/utils/v2_helper/common';
import { ref, watch } from 'vue';


const QRIS_CARD_ID = 'G485220564';
const QRIS_PRITER = '936008273111205019';

export const useAboutDownQR = () => {
  const { $t } = use18n();
  const imgloading = ref(true);
  const qrRef = ref(null);
  const qrState = ref({
    imgUrl: '',
    topText: $t('waiting.qrisCardTitle'),
    id: QRIS_CARD_ID,
    leftBottomText: `${$t('waiting.qrisCardFooterTip')}: ${QRIS_PRITER}`,
  });


  watch(() => qrState.value.imgUrl, async url => {
    if (url && qrRef.value) {
      qrRef.value.onload = async () => {
        imgloading.value = false;
      }
    }
  })
  return { qrState, qrRef, imgloading }
}
